import { type ReactNode } from "react";

import { cn } from "shared/lib";

export const DisclaimerCalloutType = {
  DEFAULT: "default",
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
  DANGER: "danger",
} as const;
export type DisclaimerCalloutType =
  (typeof DisclaimerCalloutType)[keyof typeof DisclaimerCalloutType];

export interface DisclaimerCalloutProps {
  children: ReactNode;
  className?: string;
  title: ReactNode;
  type?: DisclaimerCalloutType;
}

export function DisclaimerCallout({
  children,
  className,
  title,
  type = DisclaimerCalloutType.DEFAULT,
}: DisclaimerCalloutProps) {
  return (
    <div
      className={cn(
        "text-textPrimary text-bodymd flex flex-col gap-1 rounded border-l-4 px-5 py-4",
        {
          "bg-interfaceBgDefault border-interfaceBorder":
            type === DisclaimerCalloutType.DEFAULT,
        },
        {
          "bg-greenBgLight border-greenDefault":
            type === DisclaimerCalloutType.SUCCESS,
        },
        {
          "bg-blueBgLight border-blueDefault":
            type === DisclaimerCalloutType.INFO,
        },
        {
          "bg-yellowBgLight border-yellowDefault":
            type === DisclaimerCalloutType.WARNING,
        },
        {
          "bg-redBgLight border-redDefault":
            type === DisclaimerCalloutType.DANGER,
        },
        className,
      )}
    >
      <h3 className="text-headingmd">{title}</h3>

      {children}
    </div>
  );
}
